import {Component, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from "@angular/material/icon";
import {Translations} from "@translations";

@Component({
	selector: "sim-recording-status-tag",
	imports: [TranslateModule],
	templateUrl: "./recording-status-tag.component.html",
	styleUrl: "./recording-status-tag.component.scss",
})
export class RecordingStatusTagComponent {
	public readonly isRecording = input.required<boolean>();
	protected readonly T = Translations;
}
